import { render } from "./WebChe.vue?vue&type=template&id=4b922f0f"
import script from "./WebChe.vue?vue&type=script&lang=js"
export * from "./WebChe.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__